import React, { useEffect, useState } from "react";
import {
  faStar,
  faStarHalf,
  faTag,
  faTruckFast,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFile,
  faNoteSticky,
  faStar as faRegularStar,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { ToastContainer, toast } from "react-toastify";
import "../../styles/ReactToastify.css";
import ProductCard from "./ProductCard";
import { useParams } from "react-router-dom";
import axios from "axios";
import SizeChartModal from "./SizeChartModal";

const ReviewItem = ({ name, date, rating, comment }) => {
  const ratingStars = [];

  for (let i = 1; i <= 5; i++) {
    ratingStars.push(
      <span key={i} className={`text-yellow-500`}>
        <FontAwesomeIcon icon={i <= rating ? faStar : faRegularStar} />
      </span>
    );
  }

  return (
    <div className="py-4">
      <div className="flex items-center mb-2">
        <p className="text-sm font-bold mr-2">{name}</p>
        <p className="text-sm text-gray-600">{date}</p>
      </div>
      <div className="flex items-center mb-2">{ratingStars}</div>
      <p className="text-sm">{comment}</p>
    </div>
  );
};

export default function ProductPage({
  handleCartUpdate,
  products,
  coupons,
  reachedMax,
  setReachedMax,
}) {
  const [item, setItem] = useState({});
  const [colors, setColors] = useState({});
  const [pincodeValue, setPincodeValue] = useState();
  const [errMessage, setErrMessage] = useState();
  const [expectedDelivery, setExpectedDelivery] = useState();
  const [outOfStock, setOutOfStock] = useState(false);
  const [cartErrMessage, setCartErrMessage] = useState();
  const [dimensionsValue, setDimensionsValue] = useState({
    length: "",
    breadth: "",
    height: "",
    weight: "",
  });
  // const error = "No Item Found!";
  const { id } = useParams();

  // Getting Product details from the id
  useEffect(() => {
    // console.log("product id", id);
    if (products.length !== 0) {
      const product = products.filter((value) => value._id === id)[0];
      // console.log(product);
      setItem(product);
      setDimensionsValue({
        length: product.length,
        breadth: product.breadth,
        height: product.height,
        weight: product.weight,
      });
      // Check Inventory
      if (product.availableSize) {
        for (let i = 0; i < product.availableSize?.length; i++) {
          if (product.availableSize[i].inventory > 0) {
            setOutOfStock(false);
            break;
          }
          setOutOfStock(true);
        }
      }
    }
  }, [id, products]);

  // Creating colors object using availableColors
  useEffect(() => {
    if (item.length !== 0 && item.availableColors) {
      const newColors = item?.availableColors?.map((color) => {
        if (
          color.toLowerCase() === "black" ||
          color.toLowerCase() === "white"
        ) {
          return { [color]: `bg-${color.toLowerCase()}` };
        } else {
          return { [color]: `bg-${color.toLowerCase()}-400` };
        }
      });
      const colorsObject = newColors?.reduce((obj, item) => {
        if (item && typeof item === "object") {
          const [key] = Object.keys(item);
          obj[key] = item[key];
        }
        return obj;
      }, {});
      // console.log("nw", colorsObject);
      if (colorsObject !== undefined) {
        setColors(colorsObject);
      }
    }
  }, [item]);

  const handleSubmitPincode = (value) => {
    const pincode = value !== "" ? value : pincodeValue;
    const dimensions =
      dimensionsValue.length !== ""
        ? dimensionsValue
        : { length: 13, breadth: 15, height: 10, weight: 0.5 };
    const fetchShipmentDetails = async () => {
      await axios
        .post(`${process.env.REACT_APP_BACKEND_LINK}/getshippingdetails`, {
          pincode,
          dimensions,
        })
        .then((res) => {
          // console.log("pp", res.data.formattedDate);
          // console.log("PPShipment Charges", res.data.shipmentCharges);
          setExpectedDelivery(res.data.formattedDate);
          setErrMessage();
          localStorage.setItem("pincode", pincode);
        })
        .catch((err) => {
          console.log(err);
          setErrMessage(err.response.data);
        });
    };
    fetchShipmentDetails();
  };

  useEffect(() => {
    const fetchPincode = localStorage.getItem("pincode");
    if (fetchPincode) {
      // console.log("fetchpincode", fetchPincode);
      setPincodeValue(fetchPincode);
      // console.log("Running pincode");
      handleSubmitPincode(fetchPincode);
    }
  }, []);

  const handleChangePincode = (value) => {
    if (!/^$|^[+-]?\d+$/.test(value)) {
      return;
    } else {
      setPincodeValue(value);
    }
  };

  const handleUpdatePincode = () => {
    console.log("Removed");
    setPincodeValue("");
    setExpectedDelivery();
    localStorage.removeItem("pincode");
  };

  // const reviews = [
  //   {
  //     id: 1,
  //     name: "John Doe",
  //     date: "May 1, 2023",
  //     rating: 5,
  //     comment:
  //       "This product is amazing! I would highly recommend it to anyone.",
  //   },
  //   {
  //     id: 2,
  //     name: "Jane Smith",
  //     date: "April 30, 2023",
  //     rating: 4,
  //     comment: "I really like this product, but I wish it came in more colors.",
  //   },
  //   // Add more reviews here
  // ];

  // Create one single Object for storing all data for order.
  const [selectedColor, setSelectedColor] = useState();
  const [selectedSize, setSelectedSize] = useState();
  const [inventory, setInventory] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    // console.log("opened");
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Shows side toast on adding to cart
  useEffect(() => {
    if (reachedMax !== 0) {
      if (reachedMax === 200) {
        // console.log("Showing toast 200");
        toast.success("Added to Cart!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (reachedMax === 500) {
        // console.log("Showing toast 500");
        toast.error("Already max quantity in cart", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      setReachedMax(0);
    }
  }, [reachedMax]);

  const customRenderThumb = (children) =>
    item.images &&
    item.images.map((image) => {
      return (
        <div
          key={image}
          className="w-full h-full rounded-lg flex justify-center items-center"
        >
          <img src={image} className="h-16 rounded-lg w-full" alt="" />
        </div>
      );
    });

  return (
    <div>
      <section className="flex flex-col md:flex-row justify-between items-center">
        <div className="md:w-1/2 md:pt-16 md:p-8 pt-10">
          <div className="flex flex-col">
            <div className="w-full flex justify-center">
              <Carousel
                showThumbs={true}
                renderThumbs={customRenderThumb}
                showStatus={false}
                autoPlay={true}
                interval={3000}
                stopOnHover={true}
                infiniteLoop={true}
              >
                {item.images &&
                  item.images.map((image) => (
                    <img
                      key={image}
                      // src={image}
                      src="https://picsum.photos/100"
                      className="rounded-2xl"
                      alt=""
                    />
                  ))}
              </Carousel>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 md:p-10 pt-10">
          <h1 className="text-3xl">
            {item.brandName + " " + item.productName}
            {item.color && " (" + item.color + ") "}
          </h1>
          <p>
            {item.rating &&
              (() => {
                const stars = [];
                for (let i = 0; i < Math.floor(item.rating); i++) {
                  stars.push(
                    <FontAwesomeIcon
                      icon={faStar}
                      className="text-yellow-400"
                    />
                  );
                }
                if (item.rating % 1 !== 0) {
                  stars.push(
                    <FontAwesomeIcon
                      icon={faStarHalf}
                      className="text-yellow-400"
                    />
                  );
                }
                return stars;
              })()}

            {item.rating && "  (" + Math.floor(item.rating * 10) / 10 + ")"}
          </p>
          <hr className="mt-3" />
          <div className="py-5 flex font-semibold text-2xl">
            <span className="font-normal">₹</span>
            {item.price}
            {item.mrp && (
              <p>
                <span className="pl-3 text-lg font-normal">MRP</span>
                <span className="pl-1 text-lg line-through font-normal">
                  ₹{item.mrp}
                </span>
                <span className="pl-3 font-normal text-ambhosOrange">
                  {"(" +
                    Math.floor((item.discount / item.mrp) * 100) +
                    "% off)"}
                </span>
              </p>
            )}
          </div>
          {/* Color Selection */}
          {item.availableColors && (
            <div className="flex space-x-2 mb-5">
              {Object.keys(colors).map((color) => {
                console.log(color, colors[color]);
                return (
                  <div
                    key={color}
                    className={
                      selectedColor === color
                        ? "border-2 border-ambhosOrange p-1 rounded-full"
                        : "p-1 rounded-full cursor-pointer"
                    }
                  >
                    <div
                      onClick={() => setSelectedColor(color)}
                      className={`h-6 w-6 rounded-full ${colors[color]}`}
                    ></div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Size Selection */}
          {item.availableSize && (
            <div className="w-64">
              <div className="flex justify-between">
                <p className="text-[15px] mb-2 font-semibold">Select Size</p>
                {item.sizeChart !== "" && (
                  <>
                    <p
                      className="text-[15px] mb-2 font-semibold text-ambhosOrange cursor-pointer"
                      onClick={openModal}
                    >
                      Size Chart
                    </p>
                    <SizeChartModal
                      isOpen={isModalOpen}
                      imageUrl={item.sizeChart}
                      closeModal={closeModal}
                    />
                  </>
                )}
              </div>
              <div
                className={
                  cartErrMessage ? "flex space-x-2 mb-2" : "flex space-x-2 mb-5"
                }
              >
                {item.availableSize?.map(
                  (size) =>
                    size.inventory > 0 && (
                      <div
                        key={size.size}
                        onClick={() => {
                          setSelectedSize(size.size);
                          setInventory(size.inventory);
                          setCartErrMessage("");
                        }}
                        className={
                          selectedSize === size.size
                            ? "w-10 h-10 flex justify-center items-center border-2 border-ambhosOrange rounded-full"
                            : "w-10 h-10 flex justify-center items-center border-2 border-gray-400 rounded-full cursor-pointer"
                        }
                      >
                        <p className="p-1">{size.size}</p>
                      </div>
                    )
                )}
              </div>
              {cartErrMessage && (
                <p className="text-sm text-red-500 mb-5">{cartErrMessage}</p>
              )}
            </div>
          )}
          {!outOfStock ? (
            <button
              className="border-2 border-ambhosOrange rounded-md bg-ambhosOrange text-white px-20 py-2 font-medium hover:opacity-90"
              onClick={() => {
                if (item.availableSize) {
                  if (selectedSize) {
                    handleCartUpdate(id, selectedSize, inventory);
                  } else {
                    setCartErrMessage("Select Size");
                  }
                } else {
                  handleCartUpdate(id, selectedSize, inventory);
                }
              }}
            >
              Add to Cart
            </button>
          ) : (
            <p className="text-2xl font-semibold text-red-500">Out of Stock</p>
          )}
          <hr className="mt-3" />
          <h2 className="pt-5 text-md text-black font-semibold">
            <FontAwesomeIcon
              icon={faTruckFast}
              className="mr-2 text-gray-500"
            />
            DELIVERY SERVICE
          </h2>
          <div className="mt-3 inline-block border-2 rounded-md p-1 px-2">
            <input
              type="text"
              name="pincode"
              placeholder="Enter pincode"
              value={pincodeValue}
              onChange={(e) => handleChangePincode(e.target.value)}
              disabled={expectedDelivery}
              maxLength="6"
              className="outline-none text-sm"
            />
            {!expectedDelivery ? (
              <button
                onClick={() => handleSubmitPincode("")}
                className="text-sm font-medium text-ambhosOrange"
              >
                Check
              </button>
            ) : (
              <button
                onClick={handleUpdatePincode}
                className="text-sm font-medium text-ambhosOrange"
              >
                Change
              </button>
            )}
          </div>
          {expectedDelivery && (
            <p>
              Get it by{" "}
              <span className="font-semibold">{expectedDelivery}</span>
            </p>
          )}
          {errMessage && <p className="text-sm text-red-500">{errMessage}</p>}

          <h2 className="pt-5 text-md text-black font-semibold">
            <FontAwesomeIcon icon={faTag} className="mr-2 text-gray-500" />
            BEST OFFERS
          </h2>
          <ul className="list-[square] mt-2 pl-5 marker:text-xs text-[16px] text-black space-y-1">
            {coupons.map((coupon) => (
              <li key={coupon.code}>
                Use Coupon <span className="font-semibold">{coupon.code}</span>{" "}
                for ₹{coupon.discount} off on orders above ₹{coupon.minPrice}
              </li>
            ))}
          </ul>
          <hr className="mt-3" />
        </div>
      </section>

      <section>
        <h2 className="py-5 text-md text-black font-semibold">
          <FontAwesomeIcon icon={faNoteSticky} className="mr-2 text-gray-500" />
          PRODUCT DETAILS
        </h2>
        <ul className="list-disc pl-5 space-y-1 marker:text-xs">
          <li>
            Package Dimensions : {item.length} x {item.breadth} x {item.height}{" "}
            cm
          </li>
          <li>Weight : {item.weight} kg</li>
          <li>Country of Origin : {item.countryOfOrigin}</li>
          <li>SKU Id : {item.skuId}</li>
          {/* <li>Net Quantity : 1.00 count</li> */}
        </ul>

        <hr className="mt-3" />

        <h2 className="py-5 text-md text-black font-semibold">
          <FontAwesomeIcon icon={faFile} className="mr-2 text-gray-500" />
          PRODUCT DESCRIPTION
        </h2>
        <p>{item.description}</p>

        <hr className="mt-3" />
        {item.reviews && (
          <>
            <h2 className="py-5 text-md text-black font-semibold">
              <FontAwesomeIcon icon={faStar} className="mr-2 text-gray-500" />
              RATINGS & REVIEWS
            </h2>
            {item.reviews.map((review) => (
              <ReviewItem
                key={review.id}
                name={review.name}
                date={review.date}
                rating={review.rating}
                comment={review.comment}
              />
            ))}
          </>
        )}
      </section>

      <section className="mt-16">
        <h1 className="text-2xl md:text-3xl font-semibold">Similar Products</h1>
        <div className="mt-5 flex space-x-5 overflow-scroll scrollbar-hide">
          {products.map((product) => {
            if (product._id !== id) {
              return (
                <div key={product._id}>
                  <ProductCard
                    id={product._id}
                    image={product?.images[0]}
                    title={product.productName}
                    brand={product.brandName}
                    color={product.color}
                    sizes={product.availableSize ? product.availableSize : []}
                    rating={product.rating ? product.rating : ""}
                    price={product.price}
                    mrp={product.mrp}
                    handleCartUpdate={handleCartUpdate}
                  />
                </div>
              );
            }
          })}
        </div>
      </section>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}
